import React, { useState, useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import SidebarContext from '../../contexts/sidebar';
import AuthContext from '../../contexts/auth';
import { translate } from '../../utils/Common';
// Same Lucide family as the sidebar: the two navigations show the same modules
// and used to draw them with different icon sets.
import { LuHome, LuPackage, LuBoxes, LuSettings } from 'react-icons/lu';
import { cn } from '@/lib/utils';
import SubmenuModal from './SubmenuModal';
import MenuDrawer from './MenuDrawer';
import UserMenu from '../common/UserMenu';

const BottomNavigation = () => {
    const sidebarContext = useContext(SidebarContext);
    const userContext = useContext(AuthContext);
    const location = useLocation();
    const history = useHistory();
    
    const [isPackagesModalOpen, setIsPackagesModalOpen] = useState(false);
    const [isPlatformsModalOpen, setIsPlatformsModalOpen] = useState(false);
    const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

    // Solo mostrar en móviles
    if (!sidebarContext.isMobile) {
        return null;
    }

    const isActive = (path) => {
        if (path === '/dashboard/') {
            return location.pathname === '/dashboard' || location.pathname === '/dashboard/';
        }
        return location.pathname.startsWith(path);
    };

    const handleHomeClick = () => {
        history.push('/dashboard/');
        setIsProfileMenuOpen(false);
    };

    const handlePackagesClick = () => {
        setIsPackagesModalOpen(true);
        setIsProfileMenuOpen(false);
    };

    const handleMenuClick = () => {
        setIsMenuDrawerOpen(true);
        setIsProfileMenuOpen(false);
    };

    const handleProfileClick = () => {
        setIsProfileMenuOpen(!isProfileMenuOpen);
    };

    const handleProfileOption = (path) => {
        history.push(path);
        setIsProfileMenuOpen(false);
    };



    const handleLogout = () => {
        userContext.signOut();
        setIsProfileMenuOpen(false);
        history.push('/login');
    };

    return (
        <>
            <nav className="fixed bottom-0 left-0 right-0 z-[900] flex items-center justify-around border-t border-border bg-card py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] shadow-[0_-2px_10px_rgba(0,0,0,0.06)]">
                <button
                    className={cn('flex max-w-[20%] flex-1 flex-col items-center justify-center gap-1 border-0 bg-transparent px-3 py-2 text-muted-foreground transition-colors focus:outline-none active:scale-95', isActive('/dashboard/') && 'text-primary')}
                    onClick={handleHomeClick}
                    aria-label={translate('sidebar.options.start')}
                >
                    <LuHome className="shrink-0 transition-transform" size={22} />
                    <span className="max-w-full truncate text-[10px] font-medium">{translate('sidebar.options.start')}</span>
                </button>

                <button
                    className={cn('flex max-w-[20%] flex-1 flex-col items-center justify-center gap-1 border-0 bg-transparent px-3 py-2 text-muted-foreground transition-colors focus:outline-none active:scale-95', isActive('/dashboard/packages') && 'text-primary')}
                    onClick={handlePackagesClick}
                    aria-label={translate('sidebar.options.packages')}
                >
                    <LuPackage className="shrink-0 transition-transform" size={22} />
                    <span className="max-w-full truncate text-[10px] font-medium">{translate('sidebar.options.packages')}</span>
                </button>

                <button
                    className={cn('flex max-w-[20%] flex-1 flex-col items-center justify-center gap-1 border-0 bg-transparent px-3 py-2 text-muted-foreground transition-colors focus:outline-none active:scale-95', 'relative')}
                    onClick={handleMenuClick}
                    aria-label={translate('sidebar.menu.title')}
                >
                    <img src="/img/logo-b-v2.png" alt="" aria-hidden="true" className="size-8 object-contain" />
                    <span className="max-w-full truncate text-[10px] font-medium">{translate('sidebar.menu.title')}</span>
                </button>

                <button
                    className={cn('flex max-w-[20%] flex-1 flex-col items-center justify-center gap-1 border-0 bg-transparent px-3 py-2 text-muted-foreground transition-colors focus:outline-none active:scale-95', isActive('/dashboard/platforms') && 'text-primary')}
                    onClick={() => {
                        setIsPlatformsModalOpen(true);
                        setIsProfileMenuOpen(false);
                    }}
                    aria-label={translate('sidebar.options.platforms')}
                >
                    <LuBoxes className="shrink-0 transition-transform" size={22} />
                    <span className="max-w-full truncate text-[10px] font-medium">{translate('sidebar.options.platforms')}</span>
                </button>

                <div className="relative flex max-w-[20%] flex-1 justify-center">
                    <button
                        className={cn('flex max-w-[20%] flex-1 flex-col items-center justify-center gap-1 border-0 bg-transparent px-3 py-2 text-muted-foreground transition-colors focus:outline-none active:scale-95', isProfileMenuOpen && 'text-primary')}
                        onClick={handleProfileClick}
                        aria-label={translate('bottomNav.settings')}
                    >
                        <LuSettings className="shrink-0 transition-transform" size={22} />
                        <span className="max-w-full truncate text-[10px] font-medium">{translate('bottomNav.settings')}</span>
                    </button>

                    <UserMenu
                        isOpen={isProfileMenuOpen}
                        onClose={() => setIsProfileMenuOpen(false)}
                        onProfileClick={() => handleProfileOption('/dashboard/profile')}
                        onLogout={handleLogout}
                        variant="default"
                    />
                </div>
            </nav>

            <SubmenuModal
                isOpen={isPackagesModalOpen}
                onClose={() => setIsPackagesModalOpen(false)}
                type="packages"
            />

            <SubmenuModal
                isOpen={isPlatformsModalOpen}
                onClose={() => setIsPlatformsModalOpen(false)}
                type="platforms"
            />

            <MenuDrawer
                isOpen={isMenuDrawerOpen}
                onClose={() => setIsMenuDrawerOpen(false)}
            />

        </>
    );
};

export default BottomNavigation;

